/* jshint esversion: 6 */
/* global angular, $injector, $bridges, $rootScope, $q, $timeout, $signals, IB, $objectCache, TaskDataService, isCMS, isPreviewForSaveOps */

/**
 * RepositoryEntry class represents an entry in the repository with various states and operations.
 */
class RepositoryEntry {

    

    /**
     * Constructs a new RepositoryEntry instance.
     */
    constructor(data, $injector) {
        this.context = $injector.get('TaskDataService');
        this.manuallyFlaggedAsDirty = false;
        this.manuallyFlaggedAsDeleted = false;
        this.data = data;
        this.diff = undefined;
        this.saved = false;
        this.originData = angular.copy(data);
        this.type = data.type;
        this.$rootScope = $injector.get('$rootScope');
        this.$bridges = $injector.get('$bridges');
        this.$objectCache = $injector.get('$objectCache');
        this.$injector = $injector;
        this.$q = $injector.get('$q');
        if ("data" in data) {
            delete data.data;
        }
        Object.assign(this, data);
    }

    /**
     * Initializes the diff data for this entry.
     * @private
     */
    _initDiffData() {
        var isPreview = this.$rootScope.isPreview;

        if (!isPreview && typeof (this.diff) !== 'undefined') {
            return;
        }
        if (isPreview && typeof (this.previewDiff) !== 'undefined') {
            return;
        }

        if (angular.isUndefined(this.getUUID())) {
            if (this.constructor.name !== "Container") {
                console.error("UNDEFINED UUID ", this);
            } else {
                console.warn("UNDEFINED UUID ", this);
            }
            return;
        }
        var serializedDiff = this.$bridges.data().get(this.getUUID()),
            shallCreateDiff = false;

        var isCMSNotPreview = isCMS && !this.$rootScope.isPreview;

        if (typeof serializedDiff === 'string') {
            try {
                var parsedDiff = JSON.parse(serializedDiff);
                if (this.$rootScope.isPreview) {
                    this.previewDiff = parsedDiff;
                } else {
                    this.diff = parsedDiff;
                }
            } catch (error) {
                shallCreateDiff = true;
            }

            shallCreateDiff = shallCreateDiff || typeof this.diff !== 'object';

        } else if (isCMSNotPreview) {
            shallCreateDiff = true;
        }

        if (shallCreateDiff) {
            if (this.$rootScope.isPreview) {
                this.previewDiff = {};
            } else {
                this.diff = {};
            }
        }
    }

    /**
     * Gets the UUID of this entry.
     * @returns {string} The UUID of this entry.
     */
    getUUID() {
        return this.data.uuid;
    }

    /**
     * Resets the changes made to this entry.
     */
    resetChanges() {
        this.diff = undefined;
    }

    /**
     * Checks if there are any diff changes in this entry.
     * @returns {boolean} True if there are diff changes, otherwise false.
     */
    hasDiffChanges() {
        if (this.manuallyFlaggedAsDirty) {
            return true;
        }

        if (typeof (this.diff) === 'undefined') {
            return false;
        }

        for (var k in this.diff) {
            if (this.diff.hasOwnProperty(k)) {
                return true;
            }
        }

        return false;
    }

    /**
     * Flags this entry as dirty.
     */
    flagAsDirty() {
        this.context.flagEntityAsDirty(this);
        this.manuallyFlaggedAsDirty = true;
        var isCMSNotPreview = isCMS && !$this.rootScope.isPreview;
        if (isCMSNotPreview) {
            var _this = this;
            $timeout(function () {
                _this.validate(null);
            });
        }
    }

    /**
     * Flags this entry as deleted.
     */
    flagAsDeleted() {
        this.context.flagEntityAsDeleted(this);
        this.manuallyFlaggedAsDeleted = true;
        var isCMSNotPreview = isCMS && !$this.rootScope.isPreview;
        if (isCMSNotPreview) {
            var _this = this;
            $timeout(function () {
                _this.validate(null);
                _this.unbindValidate();
            });
        }
    }

    /**
     * Checks if this entry is flagged as deleted.
     * @returns {boolean} True if flagged as deleted, otherwise false.
     */
    isFlaggedAsDeleted() {
        return this.manuallyFlaggedAsDeleted;
    }

    /**
     * Sets this entry as saved.
     */
    setAsSaved() {
        this.manuallyFlaggedAsDirty = false;
        this.manuallyFlaggedAsDeleted = false;
        this.saved = true;
        this.originData = angular.copy(this.data);
    }

    /**
     * Checks if this entry is saved.
     * @returns {boolean} True if saved, otherwise false.
     */
    isSaved() {
        return this.saved;
    }

    /**
     * Checks if this entry has changed.
     * @returns {boolean} True if changed, otherwise false.
     */
    isChanged() {
        return !(angular.toJson(this.data) === angular.toJson(this.originData)) || angular.isDefined(this.diff);
    }

    /**
     * Gets the parent entry for this entry.
     * @param {string} filterType - The type to filter by.
     * @returns {Object} The parent entry.
     */
    getParentEntry(filterType) {
        return TaskDataService.fetchContext().getParentEntryForUUID(this.getUUID(), filterType);
    }

    /**
     * Monitors changes using an observer.
     */
    monitorChangesUsingObserver() {
    }

    /**
     * Saves this entry.
     * @returns {Promise} A promise that resolves when the entry is saved.
     */
    save() {
        var future = this.$q.defer();
        var curDiff = this.$rootScope.isPreview ? this.previewDiff : this.diff;
        var key = this.getUUID(),
            data = angular.isDefined(curDiff) ? JSON.stringify(curDiff, null, " ") : null,
            t = this;

        if (typeof this.onBeforeSave === 'function') {
            this.onBeforeSave();
        }

        var isCMSNotPreview = isCMS && !$this.rootScope.isPreview;

        if (curDiff || this.manuallyFlaggedAsDirty) {
            if (isCMSNotPreview) {
                if (this.manuallyFlaggedAsDeleted) {
                    console.log('Data RepositoryEntry save() CMS', this.getUUID(), this.type);

                    this.$bridges.data().put(key, data, this.data, function (success_, err) {
                        if (success_) {
                            if (this.$rootScope.isPreview) {
                                future.resolve(t);
                                return;
                            }
                            var weakData = t.data;
                            if (!angular.isDefined(weakData.entity_content)) {
                                console.warn("@todo remove entity_content hack", t);
                                weakData.entity_content = {};
                            }
                            angular.forEach(curDiff, function (value, key) {
                                weakData.entity_content[key] = value;
                            });
                            t.diff = undefined;
                            t.manuallyFlaggedAsDirty = false;

                            future.resolve(t);
                        } else {
                            future.reject(t, err);
                            console.log("** store put fail", t, err);
                        }

                    });
                } else {
                    console.log('Data RepositoryEntry save()/remove CMS', this.getUUID(), this.type);
                    this.$bridges.data().remove(key, function (success_, err_) {
                        if (success_) {
                            future.resolve(t);

                        } else {
                            future.reject(t, err_);
                            console.log("** store remove failed", t, err_);
                        }
                    });
                }
            } else {
                
                if (!this.manuallyFlaggedAsDeleted) {
                    this.$bridges.data().put(key, data, this.data);
                } else {
                    this.$bridges.data().remove(key);
                }

                future.resolve(t);
            }
        } else if (isCMSNotPreview && curDiff === undefined) {
            console.log('Data RepositoryEntry save() CMS/nullify', this.getUUID(), this.type);
            this.$bridges.data().put(key, null, this.data, function (success_, err) {
                if (success_) {
                    future.resolve(t);
                } else {
                    future.reject(t);
                }
            });
        } else {
            future.reject(t);
        }

        if (!this.$rootScope.isPreview) {
            this.manuallyFlaggedAsDirty = false;
            this.manuallyFlaggedAsDeleted = false;
        }

        return future.promise;
    }

    /**
     * Dumps the data and diff of this entry to the console.
     */
    dump() {
        if (console && console.log) {
            console.log('this.data', this.data);
            console.log('this.diff', this.diff);
        }
    }

    /**
     * Fires a model change event.
     */
    fireModelChange() {
        this.$signals.emit(IB.Signals.MODELCHANGE, {
            model: this
        });
    }

    /**
     * Creates a readable accessor for the given attribute.
     * @param {string} attribute - The attribute to create the accessor for.
     * @param {string} objectType - The type of the object.
     */
    readable(attribute, objectType) {
        var that = this,
            prefix = objectType === Boolean ? 'is' : 'get',
            funcName = prefix + attribute.charAt(0).toUpperCase() + attribute.slice(1);

        that[funcName] = (function (attrib) {
            return function (cloneObjects) {
                var origData = that.data[attrib];
                var result;
                if ((typeof (origData) === "object") && (cloneObjects === true)) {
                    if (origData.hasOwnProperty("data")) {
                        delete origData["data"];
                    }    
                    result = Object.assign({}, origData);
                } else {
                    result = origData;
                }

                var isPreview = this.$rootScope.isPreview;
                var curDiff = isPreview ? that.previewDiff : that.diff;
                if (typeof curDiff === 'object') {
                    if (curDiff.hasOwnProperty(attrib)) {
                        result = curDiff[attrib];
                    }
                }

                return result;
            };
        })(attribute);
    }

    /**
     * Creates a writable accessor for the given attribute.
     * @param {string} attribute - The attribute to create the accessor for.
     * @param {string} objectType - The type of the object.
     */
    writable(attribute, objectType) {
        var that = this,
            prefix = objectType === Boolean ? 'setIs' : 'set',
            funcName = prefix + attribute.charAt(0).toUpperCase() + attribute.slice(1);

        this._initDiffData();

        that[funcName] = (function (attrib) {
            return function (data) {

                var translateToCorrectType = function (d) {
                    if (angular.isObject(d) && angular.isFunction(d.getUUID)) {
                        return d.getUUID();
                    }
                    return d;
                };

                var dataToWrite = translateToCorrectType(data);

                if (angular.isArray(data)) {
                    dataToWrite = [];
                    angular.forEach(data, function (d) {
                        dataToWrite.push(translateToCorrectType(d));
                    });
                }

                var isPreviewForSaveOps = this.$rootScope.isPreview;

                if (isPreviewForSaveOps) {
                    if (!that.previewDiff && typeof that.previewDiff !== 'object') {
                        that.previewDiff = {};
                    }
                } else {
                    if (!that.diff && typeof that.diff !== 'object') {
                        that.diff = {};
                    }
                }

                var isPrimitiveType = function (dt) {
                    if (!angular.isDefined(dt)) {
                        return false;
                    }
                    return angular.isString(dt) || angular.isNumber(dt);
                };

                var definitelyDidNotChange = false;
                if (isPrimitiveType(dataToWrite) && that.data.hasOwnProperty(attrib) && isPrimitiveType(that.data[attrib])) {
                    definitelyDidNotChange = dataToWrite === that.data[attrib];
                }

                if (!definitelyDidNotChange) {
                    if (isPreviewForSaveOps) {
                        that.previewDiff[attrib] = dataToWrite;
                    } else {
                        that.diff[attrib] = dataToWrite;
                        that.flagAsDirty();
                    }
                }
            };
        })(attribute);
    }

    /**
     * Creates both readable and writable accessors for the given attribute.
     * @param {string} attributes - The attribute to create the accessors for.
     * @param {string} objectType - The type of the object.
     */
    accessable(attributes, objectType) {
        this.writable(attributes, objectType);
        this.readable(attributes, objectType);
    }

    /**
     * Creates a referenced accessor for the given attribute.
     * @param {string} attribute - The attribute to create the accessor for.
     * @param {string} objectType - The type of the object.
     */
    referenced(attribute, objectType) {
        var that = this,
            funcName = 'get' + attribute.charAt(0).toUpperCase() + attribute.slice(1),
            isWildCardType = ("*" === objectType);

        that[funcName] = (function (attrib) {
            return function (errorIfNotFound_) {

                var result, uuids, uuid,
                    errorIfNotFound = angular.isDefined(errorIfNotFound_) ? errorIfNotFound_ : true;

                var objectGetterWithGivenType = function (uuid) {
                    var repoDoc = that.context.readEntryByUUID(uuid, errorIfNotFound);
                    if (!angular.isDefined(repoDoc)) {
                        return null;
                    }
                    //var decoratedObj = new objectType(repoDoc);
                    console.log('objectType', repoDoc.type,  objectType.constructor.name, objectType, that);
                    var modelFactory = that.context.getModelFactory(repoDoc.type); //objectType.constructor.name);
                    var decoratedObj = that.$injector.instantiate(modelFactory, { entry: repoDoc, TaskDataService: that.context });                    
                    return decoratedObj;
                };
                var objectGetterWithoutGivenType = function (uuid) {
                    var obj = that.context.read(uuid, errorIfNotFound);
                    if (!angular.isDefined(obj)) {
                        return null;
                    }
                    return obj;
                };
                //var objectGetter = isWildCardType ? objectGetterWithoutGivenType : objectGetterWithGivenType;
                const objectGetter = objectGetterWithoutGivenType;

                var attribValue = that.data[attrib];
                if (typeof that.diff === 'object') {
                    if (that.diff.hasOwnProperty(attrib)) {
                        attribValue = that.diff[attrib];
                    }
                }

                if (typeof (attribValue) === 'undefined' || attribValue === null || attribValue === "" || attribValue === false) {
                    return null;
                } else if (typeof attribValue !== 'string') {

                    result = [];
                    uuids = attribValue;

                    for (var idx = 0; idx < uuids.length; idx++) {
                        uuid = uuids[idx];

                        if (!this.$objectCache.hasUUID(uuid)) {
                            var decoratedObj = objectGetter(uuid);
                            if (decoratedObj !== null) {
                                this.$objectCache.put(decoratedObj);
                            } else {
                                console.warn("Warning, value for UUID " + uuid + " in collection " + funcName + " is null");
                                this.$objectCache.putAsNull(uuid);
                            }
                        }

                        if (this.$objectCache.hasUUID(uuid)) {
                            var cachedObj = this.$objectCache.get(uuid);
                            if (cachedObj !== null) {
                                result.push(cachedObj);
                            } else {
                                console.warn("Warning, cache value for UUID " + uuid + " in collection " + funcName + " is null");
                            }
                        } else {
                            console.warn("Warning, cache value for UUID " + uuid + " in collection " + funcName + " is not available, even though it should be");
                        }
                    }
                } else {
                    uuid = attribValue;
                    if (!this.$objectCache.hasUUID(uuid)) {
                        var decoratedObject = objectGetter(uuid);
                        if (decoratedObject !== null) {
                            this.$objectCache.put(decoratedObject);
                        } else {
                            this.$objectCache.putAsNull(uuid);
                            console.warn("Warning, value for UUID " + uuid + " in " + funcName + " is null");
                        }
                    }

                    if (this.$objectCache.hasUUID(uuid)) {
                        var cachedObject = this.$objectCache.get(uuid);
                        if (cachedObject !== null) {
                            result = cachedObject;
                        } else {
                            console.warn("Warning, cache value for UUID " + uuid + " in " + funcName + " is null");
                        }
                    } else {
                        console.warn("Warning, cache value for UUID " + uuid + " in " + funcName + " is not available, even though it should be");
                    }
                }

                return result;
            };
        })(attribute);

        this.writable(attribute, objectType);
    }

    __configureAccessors(methodName, list) {
        var attribute, objectType;
        
        for (attribute in list) {
            if (list.hasOwnProperty(attribute)) {
                objectType = list[attribute];
                this[methodName](attribute, objectType);
            }
        }
    }

    getUUID() {
        return this.data.uuid;
    }

    readables(readables) {        
        this.__configureAccessors('readable', readables);
    }

    writables(writeables) {
        this.__configureAccessors('writable', writeables);
    }

    accessables(accessables) {
        this.__configureAccessors('accessable', accessables);
    }

    references(references) {
        this.__configureAccessors('referenced', references);
    }

    validators(validators) {
        //this.__configureAccessors('validator', validators);
        //console.warn('RepositoryEntry.validators() is not yet implemented', this);
    }
}

RepositoryEntry.$inject = ['$injector'];

export default RepositoryEntry;